// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_recordPropertySearchEventV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RecordPropertySearchEventV5Success"]);
}

let variablesConverter = {"recordPropertySearchEventV5Input":{"occurredAt":{"b":""}},"__root":{"input":{"r":"recordPropertySearchEventV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"recordPropertySearchEventV5":{"u":"response_recordPropertySearchEventV5"}}};

let wrapResponseConverterMap = {
  response_recordPropertySearchEventV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"recordPropertySearchEventV5":{"u":"response_recordPropertySearchEventV5"}}};

let responseConverterMap = {
  response_recordPropertySearchEventV5: unwrap_response_recordPropertySearchEventV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function forSalePropertyV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "UNDER_CONTRACT" || $$enum === "SOLD") {
    return $$enum;
  }
}

let forSalePropertyV5FilterableStatus_fromString = forSalePropertyV5FilterableStatus_decode;

function propertySearchSortOrder_decode($$enum) {
  if ($$enum === "RECENTLY_BROADCAST" || $$enum === "RECENTLY_UPDATED_EXCLUDING_RENEWALS" || $$enum === "RECENTLY_UPDATED") {
    return $$enum;
  }
}

let propertySearchSortOrder_fromString = propertySearchSortOrder_decode;

function rentalPropertyFilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "RENTED") {
    return $$enum;
  }
}

let rentalPropertyFilterableStatus_fromString = rentalPropertyFilterableStatus_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  forSalePropertyV5FilterableStatus_decode: forSalePropertyV5FilterableStatus_decode,
  forSalePropertyV5FilterableStatus_fromString: forSalePropertyV5FilterableStatus_fromString,
  propertySearchSortOrder_decode: propertySearchSortOrder_decode,
  propertySearchSortOrder_fromString: propertySearchSortOrder_fromString,
  rentalPropertyFilterableStatus_decode: rentalPropertyFilterableStatus_decode,
  rentalPropertyFilterableStatus_fromString: rentalPropertyFilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertiesPageRelay_RecordPropertySearchEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "recordPropertySearchEventV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "RecordPropertySearchEventV5Success",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PropertiesPageRelay_RecordPropertySearchEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "recordPropertySearchEventV5",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3007fb6314cade979694bc38adcd220b",
    "id": null,
    "metadata": {},
    "name": "PropertiesPageRelay_RecordPropertySearchEventMutation",
    "operationKind": "mutation",
    "text": "mutation PropertiesPageRelay_RecordPropertySearchEventMutation(\n  $input: RecordPropertySearchEventV5Input!\n) {\n  recordPropertySearchEventV5(input: $input) {\n    __typename\n    ... on RecordPropertySearchEventV5Success {\n      __typename\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_recordPropertySearchEventV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_recordPropertySearchEventV5 = unwrap_response_recordPropertySearchEventV5;
exports.wrap_response_recordPropertySearchEventV5 = wrap_response_recordPropertySearchEventV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
